module.exports = __webpack_public_path__ + "img/icon-chat.14410f4.svg";